import { Component, HostListener, OnInit } from '@angular/core';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { Router } from '@angular/router';
import { EventsService } from 'src/app/providers/events/events.service';
import { AlertController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit {
  contactForm: FormGroup;
  user: any;
  fullname: string;
  email:string;
  username:string;
  year:number;

  constructor(
    public storageService: StorageService,
    public apiService: ApiService,
    private formBuilder: FormBuilder,
    public router: Router,
    public events: EventsService,
    public navCtrl: NavController,
    private alertController: AlertController,
    ) { 
      this.contactForm = this.formBuilder.group({
        name: [],
        email: [],
        username: [],
        subject: ['', [Validators.required]],
        message: ['', [Validators.required, Validators.minLength(6)]],
    });
  }
  ionViewDidEnter() {
    this.year = new Date().getFullYear();   
    
    document.title = "Medbill Client Portal - Contact"; 
  }

  ngOnInit() {
      this.getUser();
  }
  async getUser() {
    await this.storageService
      .getObject('userInfo')
      .then((result) => {
        if (result != null) {
          this.user = result;
          this.events.publish('user:active', this.user);
        }
      })
      .catch((e) => {
        // Handle errors here
      });

    await this.storageService
    .getObject('mbeUser')
    .then((result) => {
      if (result != null) {
        this.user = result;
        this.fullname = this.user.first_name + ' ' + this.user.last_name;
        this.email = this.user.email;
        this.username = this.user.username;
        this.contactForm.patchValue({
          name: this.fullname,
          username: this.username, 
          email: this.email
        });
      }
    })
    .catch((e) => {
      // Handle errors here
    });
  }
  async submitContactForm() {
    //console.log(this.contactForm.value);
    if (!this.contactForm.valid)
    {
      //display alert
      //console.log('bad');
    }
    else
    {
      var contact = {
        name: this.fullname,
        username: this.username,
        email: this.email,
        emailto: 'help@medbill.com.au',
        subject: this.contactForm.controls.subject.value,
        message: this.contactForm.controls.message.value,
        User: {username: this.user.username,password: this.user.password }
      }
      
      //show loading
      this.apiService.post('contact-us', contact).subscribe(
        async (res) => {
          //console.log(res);
          //dismiss loading
          if (res.error === false) {
            //this.contactForm.reset();
            this.presentSuccessfulSubmissionAlert('Your Contact enquiry was sent successfully.  Our team will get back to you as soon as possible.');
            
            this.router.navigateByUrl('/web');
          }
        },
        (err) => {
          //dismiss loading
        }
      );
    }
  }

  logout() {
    this.apiService.weblogout();
    this.navCtrl.navigateRoot('/web', { animated: true });
  }
  async presentSuccessfulSubmissionAlert(alertmsg) {
    const alert = await this.alertController.create({
      cssClass: 'success_alert', 
      header: 'Message Sent',
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event): void {
    // Call the logout function when the user closes the window
    this.logout();
  }

}
